var _defs, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDpIconGreenOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 34 26.901",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-2 {\n        fill: #0d944a;\n      }\n\n      .cls-3 {\n        opacity: 0.5;\n        isolation: isolate;\n        fill: url(#linear-gradient-2);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 24,
    y1: 1891.4,
    x2: 24,
    y2: 1906.39,
    gradientTransform: "translate(0 -1884)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5a623"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 24.005,
    y1: 1908.33,
    x2: 24.005,
    y2: 1912.03,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24,.76S14,.53,14,9.98c0,5.6,4.5,9.34,7.93,11.67a4.53,4.53,0,0,0,2,.84,4.337,4.337,0,0,0,2-.84C29.52,19.32,34,15.58,34,10,34,.53,24.05.76,24,.76Zm0,13.18a4.26,4.26,0,1,1,.04,0Z",
    transform: "translate(0 -0.7)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.34.77c-2.56,0-2.56,0-2.56,1.94V9.2a9.894,9.894,0,0,0-3.91-.79A9.73,9.73,0,0,0,0,18v0a9.73,9.73,0,0,0,9.858,9.6H9.88a10.1,10.1,0,0,0,4-.81c.15.81.73.81,2.84.81,3.06,0,3.06,0,3.06-2.1V2.78L16.34.7Zm-6,21.28a4,4,0,1,1,4-4,4,4,0,0,1-4,4h0Z",
    transform: "translate(0 -0.7)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24,25.42c-1.53,0-2.77.39-2.76.82s1.25.77,2.78.75,2.76-.39,2.75-.82S25.56,25.4,24,25.42Z",
    transform: "translate(0 -0.7)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDpIconGreenOrange);
export default __webpack_public_path__ + "static/media/dp-icon-green-orange.e0c9fd0c662b8df85404ae896ff3375e.svg";
export { ForwardRef as ReactComponent };